import React from "react";

const FeedbackPage = (props) => {
	return <div>{props.children}</div>;
};

export default FeedbackPage;
